import React from "react";

import { ButtonWrapper, StyledButton } from "./style";

const SubmitButton = ({
  id,
  isLoading,
  onSubmitCallback,
  buttonText,
  children,
}) => (
  <ButtonWrapper>
    <StyledButton
      id={id}
      variant="primary1"
      version="v2"
      onClick={onSubmitCallback}
      isLoading={isLoading}
      disabled={isLoading}
    >
      {children}
    </StyledButton>
  </ButtonWrapper>
);

export default SubmitButton;
